import { render } from "./ProfileCell.vue?vue&type=template&id=fe8cea52"
import script from "./ProfileCell.vue?vue&type=script&lang=js"
export * from "./ProfileCell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__